import type { FeedbackValue } from './feedback_buttons'

export const SUBMITTED_FEEDBACK_EVENT_NAMES: Record<FeedbackValue, string> = {
  like: 'Submitted Feedback: like',
  dislike: 'Submitted Feedback: dislike',
  flag: 'Submitted Feedback: flag',
}
